import React from 'react'
import { Typography,Space} from 'antd'
import {MdInfo } from 'react-icons/md'
const {  Text } = Typography;
export default function Footer() {
    return (
        <div>
           <Space>
               <MdInfo style={{fontSize: '20px', color: '#B4B7B6'}}/>
               <Text type="secondary">
               All the information is sourced from publicly available data. Sourcewiz does not take ownership on any of the shipment information.
               </Text>
           </Space>
        </div>
    )
}
